import React from 'react';
import { Helmet } from 'react-helmet';
import { useRouteMatch } from 'react-router-dom';

import { getPageTitle } from '@/consts/metaTitle';

export const CustomTitle = ({ titlePrefix }: { titlePrefix: string }) => {
  // 可能存在 CacheRoute（没有卸载，只是被 display none），会存在 title 设置冲突
  // 只有 match 成功的才挂载 下面的 helmet
  const match = useRouteMatch();

  return match.path ? (
    <Helmet>
      <title>{getPageTitle(titlePrefix)}</title>
    </Helmet>
  ) : null;
};
